import { useMutation } from 'react-query';

import { addTechnicianForClient } from 'api/clients/clientSmartCreation/addTechnicianForClient';

export const useCreateTechnicianForClient = () => {
  const { mutate: createTechnician, isLoading } = useMutation(addTechnicianForClient);

  return { createTechnician, isLoading };
};
